const $ = require('jquery');
const SetStoreMapper = require('./atm/set-store-mapper');

module.exports = function (breakpointsService, moveFocus, $timeout, featureService, $state, shopLocatorService, storePickerService, atm) {
    return {
        restrict: 'E',
        scope: {
            store: '=',
            exit: '&'
        },
        link(scope) {
            const storeUrlsEnabled = featureService.isEnabled(featureService.features.storeUrls);
            scope.icon = {
                store: '/Images/StoreLocator/icon-pin.png'
            };

            scope.isOpeningHoursActive = false;
            scope.isDetailsActive = true;
            scope.isMapActive = false;
            scope.storePicker = storePickerService;

            scope.toggleOpeningHours = function () {
               scope.isOpeningHoursActive = !scope.isOpeningHoursActive;
            };

            scope.setSelectedStore = function (store) {
                storePickerService.setPickupByStoreNo(store.StoreNo).then((fulfilmentInfo) => {
                    const atmData = {
                        event: 'BWSAUupdateStorePreferenceStorePage',
                        store: scope.store,
                        fulfilmentInfo
                    };
                    atm.push(atmData, SetStoreMapper);

                });
            };

            scope.exitDetails = function () {
                moveFocus($('#shopLocatorSearch'));
                scope.exit();
            };

            scope.shouldUpdateUrl = function (storeUrl) {
                return storeUrl !== $state.params.store && storeUrlsEnabled;
            };

            function updateUrl() {
                const storeUrl = shopLocatorService.generateUrlParamsForStoreInfos(scope.store);
                if (scope.shouldUpdateUrl(storeUrl)) {
                    $state.transitionTo('shop.locator.store', { store: storeUrl }, { location: true, inherit: true, notify: false });
                }
            }

            function initialise() {
                scope.isSmallFormat = breakpointsService.isSmallFormat();

                if (storeUrlsEnabled) {
                    updateUrl();
                }

                // Calculate the height of the scrollable area in small format
                if (scope.isSmallFormat) {
                    $timeout(function () {
                        const headingAndPaddingHeight = 44 + 20;
                        const topBlockHeight = $('#shopLocatorDetails-topBlock').outerHeight();
                        let height = 0;
                        // We need to do this because the height of the wrapper is 0 until we set it.
                        height = $(window).innerHeight() - (headingAndPaddingHeight + topBlockHeight);
                        $('.shopLocatorDetails-wrapper').css('max-height', `calc(100vh - ${headingAndPaddingHeight + topBlockHeight}px)`);
                        $('.shopLocatorDetails-wrapper').css('height', height + 'px');
                    }, 0);
                }
            }

            scope.togglePanel = function () {
                scope.isContactActive = !scope.isContactActive;
                scope.isDetailsActive = !scope.isDetailsActive;
                scope.isMapActive = !scope.isMapActive;
            };

        //Focus for screenreaders
            moveFocus('.shopLocatorDetails');
            $timeout(initialise);

            scope.$on('window:resize', initialise);

            scope.$watch(function () {
                return scope.store;
            }, function (newStore, oldStore) {
                if (newStore !== oldStore && scope.store && storeUrlsEnabled) {
                    updateUrl();
                }
            });
        },
        template: require('./shop-locator-details-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/shop-locator-details-directive.js
 **/